import { render, staticRenderFns } from "./CanvasPresentation.vue?vue&type=template&id=db766aac&scoped=true&"
import script from "./CanvasPresentation.vue?vue&type=script&lang=js&"
export * from "./CanvasPresentation.vue?vue&type=script&lang=js&"
import style0 from "./CanvasPresentation.vue?vue&type=style&index=0&id=db766aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db766aac",
  null
  
)

export default component.exports